import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AddUser } from '@app/_models/addUser';
import { UserService } from '@app/_services';
import { LogService } from '@app/_shared/log.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-user-master-edit',
  templateUrl: './user-master-edit.component.html',
  styleUrls: ['./user-master-edit.component.css']
})
export class UserMasterEditComponent implements OnInit {
  constructor(private userService: UserService, private eventService: LogService, private formBuilder: FormBuilder,
    private modalService: NgbModal) { }

  roles: [];
  response: any;
  firstName;
  lastName;
  roleId;
  emailId;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  phoneNumber;
  id;
  editUserForm: FormGroup;

  @Input() childMessage: AddUser[];

  ngOnInit(): void {

    this.userService.getRoles()
    .pipe(first())
    .subscribe(
      data => {
        console.log("getAllroles response---", data)
        this.roles = data.respData;
      },
      error => {
        console.log(error)
      }
    )

    console.log(this.childMessage);
    this.response = this.childMessage;
    this.firstName = this.response.first_name;
    this.lastName = this.response.last_name;
    this.emailId = this.response.email;
    this.phoneNumber = this.response.phone_no;
    this.roleId = this.response.role_id;
    this.id = this.response.id;

    this.editUserForm = this.formBuilder.group({
      id: this.id,
      firstName: [''],
      lastName: [''],
      emailId: [''],
      phoneNumber: [''],
      roleId: [''],
      universityId: ['1']
    });


  }

  editUser(){
    console.log(this.editUserForm.value)

    this.userService.editUser(this.editUserForm.value)
    .pipe(first())
    .subscribe(
      data => {
        console.log("response---", data)
        if(data.respMessage == "Success"){
          this.modalService.open(this.showModalBoxTemplate);
        }
      },
      error => {
        console.log(error)
      }
    )

  }

  refresh(): void {
    // location.reload();
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('16');
    // this.returnUrl = "superAssociate";
    // this.router.navigate([this.returnUrl]);
  }

  goBack()
  {
    this.eventService.emit<string>('16');
  }

}
